import { createContext, useContext, useState } from 'react'

interface CheckoutState {
  checkoutSuccess: boolean
  setCheckoutSuccess: (value: boolean) => void
}

const useCheckoutState = (initialValue = false): CheckoutState => {
  const [checkoutSuccess, setCheckoutSuccess] = useState(initialValue)

  return { checkoutSuccess, setCheckoutSuccess }
}

const CheckoutStateContext = createContext<CheckoutState | null>(null)

export const CheckoutStateProvider = ({
  initialValue = false,
  children,
}: {
  initialValue?: boolean
  children: React.ReactNode
}) => {
  const checkoutState = useCheckoutState(initialValue)

  return (
    <CheckoutStateContext.Provider value={checkoutState}>
      {children}
    </CheckoutStateContext.Provider>
  )
}

export const useCheckoutStateContext = (): CheckoutState => {
  const context = useContext(CheckoutStateContext)
  if (!context) {
    throw new Error(
      'useCheckoutStateContext must be used within a CheckoutStateProvider'
    )
  }
  return context
}
